import React from 'react';

import cx from 'classnames';

import UserThumbnail from 'components/lane/UserThumbnail';

import { StatusChip } from './StatusChip';

import styles from './UciCard.scss';

export interface UciCardProps {
  title?: string;
  subTitle?: string;
  description?: string;
  date?: string;
  status?: string;
  id?: string;
  onSelect?: (id: string) => void;
  isActive?: boolean;
  className?: string;
  index: number;
  /** When provided, renders a 'Submitted by' avatar + name row on the card. */
  submittedByName?: string;
}

export const UciCard: React.FC<UciCardProps> = ({
  title,
  subTitle,
  date,
  status,
  description,
  id,
  isActive,
  onSelect,
  className,
  index,
  submittedByName,
}) => {
  const onClick = () => {
    if (!onSelect || !id) {
      return;
    }

    onSelect(id);
  };

  return (
    <div
      className={cx(styles.workOrderCard, isActive && styles.active, className)}
      id={id}
      onClick={onClick}
      role="button"
      tabIndex={index}
      data-test="service-request-card"
    >
      <span className={cx(styles.tertiaryText)}>{date}</span>

      {submittedByName ? (
        // When showing "Submitted by": date on its own line, then avatar+name
        // on the left and status on the right — matching the design screenshot.
        <div className={styles.submittedByRow}>
          <UserThumbnail
            user={{ name: submittedByName }}
            className={styles.submittedByThumbnail}
            labelPosition="right"
            splitName={false}
          />
          <StatusChip status={status} className={styles.statusChipInline} />
        </div>
      ) : (
        // Default layout: status floated right next to the date
        <StatusChip status={status} className={styles.statusChip} />
      )}

      <p className={cx(styles.primaryText, styles.heading)}>{title}</p>
      <p className={cx(styles.secondaryText)}>{subTitle}</p>
      <p
        className={cx(
          styles.secondaryText,
          styles.description,
          styles.twoLineClamp
        )}
      >
        {description}
      </p>
    </div>
  );
};
